import {axiosService} from "../axios.service";
import {urls} from "../../constants";


const mealsService = {
    getAll: () => axiosService.get(urls.settings.meals).then(value => value.data),
    createMeals: (data) => axiosService.post(urls.settings.meals, data).then((value) => value.data),
    updateById: (id, data) => axiosService.patch(`${urls.settings.meals }/${id}`, data).then((value) => value.data),
    deleteById: (id) => axiosService.destroy(`${urls.settings.meals}/${id}`),
};

export {
    mealsService
};